/******************************************************************************
 * TeachInPage Hook
 * version: 1.0.1, release: 10.06.2019
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

import React, { useContext, useState, useEffect, useRef, memo } from 'react';
import './TeachInPage.scss';
import { CloseButton, GroupButton, StyleButton, SelectButton, CheckButton, Dropdown } from '../Assets';
import { State, Action } from '../Provider';
import UI from '../lib.r2/ui/ui-controls';
import TextField from '@mui/material/TextField';
import { CacheManager2 } from '../lib.r2/utils/CacheManager2';
import store from '../Store';



//============================================================================= TeachInPage Hook
export default function TeachInPage() {
	const action = useContext(Action);
	const state = useContext(State);
	const pages = state.setup._pages;
	const page = state.teachInPage;

	return (
		(!state.bundle || !pages)?
		<div id='_teach-in-page'>
			<CloseButton onClick={e => action('teach-in-close')} />
			<div>{global.getLabel('no-bundle-found', 'No Bundle-Data found!')}</div>
		</div>
		:
		<div id='_teach-in-page'>
			<div className='teach-in-header'>
				<div className='teach-in-title'>{state.bundle.name}</div>
				<div className='teach-in-gtin'>{state.bundle.gtin}</div>
				<CloseButton onClick={e => action('teach-in-close')} />
			</div>

			{/* <LayoutImage src='screens/6 Teach-In Palette 1.jpg' /> */}

			{/* <div id='teach-in-view' /> */}
			<UI.PageView selectedIndex={page}
				className='teach-in-view'
				automount
				animate
				onSelect={(e, p) => {
					console.info('select page', p?.props?.page)
				}}
				onSwipe={e => {
					if (e === 'left') action('teach-in-next')
					if (e === 'right') action('teach-in-prev')
				}}
				>
				{pages.map(p => <PageBuilder
					key={p._key}
					page={p}
					// automount={p.id !== 7}
					// autounmount={p.id === 7}
				/>)}
			</UI.PageView>

			<NavigationBar
				// onSelect={setPage}
				onPrev={e => action('teach-in-prev')}
				onNext={e => action('teach-in-next')}
				onSelect={e => action('teach-in-page', e)}
				selectedIndex={page}
				setup={state.setup}
				onComplete={e => action('teach-in-complete')}
			/>

			{/* {state.mseError &&
				<UI.Dialog open={true} close={false}
					header='ERROR!'
					footer={
						state.mseErrorCode === '26' ?	//Not Referenced
						<>
							<StyleButton width={120} label='Reference' onClick={e => {
								action('ref-start');
							}} />
							<StyleButton width={120} label={global.getLabel('cancel')} onClick={e => {
								action('measure-complete');
							}} />
						</>
						:
						<StyleButton label='OK' onClick={e => {
							action('measure-complete');
						}} />
					}>
					<div className='mse-error-message'>
						{state.mseErrorCode &&
							<div>{'ErrorCode: ' + state.mseErrorCode}</div>
						}
						<div>{state.mseErrorMessage}</div>
					</div>
				</UI.Dialog>
			} */}
		</div>
	);
}


// ---------------------------------------------------------------------------- NavigationBar
const NavigationBar = memo( props => {
	const page = props.selectedIndex;
	const chapters = props.setup._chapters;

	return (
		<div className='teach-in-navigation'>
			{/* {page > 0 && */}
				<UI.IconButton className='navi-button left' icon='chevron_left'
					onClick={props.onPrev}
				/>
			{/* } */}

			<div className='navi-bar'>
				{chapters.map(ch => ch._valid && <div key={ch.name}
					// className={'navi-chapter' + (ch._firstPage <= page? ' ready' : '')}>
					className={'navi-chapter'
						+ (ch._ready? ' ready' : '')
						+ (ch._type === 'comment'? ' small' : '')
					}>
					<span>{getLabel(ch)}</span>

					{ch.pages.map(p => {
						if (!p._valid) return null;

						return <div key={p._key}
							className={'navi-page-item'
								+ (p._key <= page? ' ready' : '')
								+ (p._key === page? ' selected' : '')
							}
							onClick={e => props.onSelect(p._key)}
						/>
					})}
				</div>)}

{/* <div className='navi-chapter'>
	<span>TEST</span>
	<div className='navi-page-item'
		onClick={e => props.onSelect(0)}
	/>
</div> */}
			</div>

			{page < props.setup._numPages-1?
				<UI.IconButton className='navi-button right' icon='chevron_right'
					onClick={props.onNext}
				/>
				:
				<UI.IconButton className='navi-button right check' icon='check'
					onClick={props.onComplete}
				/>
			}
		</div>
	)
})



// ---------------------------------------------------------------------------- PageBuilder
const PageBuilder = memo( props => {
	const action = useContext(Action);
	const state = useContext(State);
	const page = props.page;
	const [list, setList] = useState();


	useEffect(() => {
		if (!props.selected) return;

		// 1. check section conditions
		const l = page.sections.filter(s => {
			// if (!s._valid) return false

			if (!s.condition) return true;

			//this section has a condition
			let c = s._bundle[s.condition.property];
			if (!c) return false;	//condition not found

console.log('---condition:', c);
			return (s.condition.equals === c || (s.condition.in && s.condition.in.indexOf(c) > -1));
		});

		// 2. goto next or prev page if nothing to show
		if (!l.length){
			console.log('page has nothing to show! jumpt ot next page ...')
			action('teach-in-page', state.teachInPage + (state.lastPage < state.teachInPage? 1 : -1));
			return
		}

		// 3. check component conditions
		// l.forEach(s => {
		// 	s.components.forEach(c => {
		// 		/// TODO
		// 	})
		// })

		setList(l);

	}, [props.selected])


	return (
		<div className='teach-in-page'>
			{list && list.map((s, i) => {
				let label = state.config.showSectionTitle && getLabel(s);
				
				return (
					<div key={i} className='teach-in-section'>

						{label &&
							<div className={'teach-in-label' + (list.length === 1? ' single' : '')
							}>{label}</div>
						}

						{s.components.map((c, i) => c._valid !== false &&
							components[c.type] && React.createElement(components[c.type], {
								key:i,
								data:c,
								autoNext:list.length === 1 && s.components.length === 1
									&& c.max !== 0 && (c.type === 'image-grid' || c.type === 'icon-grid'),
								selected:props.selected
							})
						)}
					</div>
				)
			})}
		</div>
	)
})


// ---------------------------------------------------------------------------- Textbox
const Textbox = props => {
	const com = props.data
	const [text, setText] = useState(com._bundle.comment || '')

	return (
		<div className='teach-in-comment'>
			<div className='teach-in-title'>{getLabel(com)}</div>
			<textarea
				value={text}
				onChange={e => {
					setText(e.target.value)
					com._bundle[com.property] = e.target.value
				}}
			/>
		</div>
	)
}


const RowSize = [0, 3, 3, 3, 4, 5, 3, 4, 4, 5, 5, 4, 4, 5, 5, 5, 4];

// ---------------------------------------------------------------------------- GridView
const GridView = props => {
	const action = useContext(Action);
	const state = useContext(State);

	const com = props.data;			//component
	const [selected, setSelected] = useState(com.content.filter(c => c._selected));

	
	useEffect(() => {
		if (selected[0] && com.property === 'bundletype_id'){		//package class selected
			com._bundle._bundleType = selected[0]
		}
	}, [])


	const onSelect = e => {
		console.log(e._selected? 'unselect item:' : 'select item:', e)

		// delete com._bundle?._bundleType		//clear last defined bundleType
		delete com._bundle?._multiscanMode	//clear last defined multiscanMode

		let s = [];
		if (com.max === 1){			//single selection
			if (e._selected){
				e._selected = false;
				s = [];
			}else{
				if (selected[0]) selected[0]._selected = false;
				e._selected = true;
				s = [e];
			}
		}else{						//multi selection
			if (e._selected){		//unselect
				e._selected = false;
				s = selected.filter(el => el !== e);
			}else{					//add selection
				e._selected = true;
				if (com.max && selected.length >= com.max) selected.shift()._selected = false;
				s = [...selected, e];
			}
		}

		onSelectItem(e, s, com);
		
		if (e.skipPackUnit !== undefined){
			if (e.skipPackUnit){
				action('skip-pack-unit', e._selected);
			}else{
				action('skip-pack-unit', false);
			}
		}

		setSelected(s);

		if (e._selected && props.autoNext){
			console.log('page has nothing to show! jumpt ot next page ...')
			action('teach-in-next')
		}
	}


	const content = com.content;
	const size = RowSize[content.length] || 5;

	return (
		<div className='tic-grid'>
			{content.map((e, i) =>
				e._valid !== false &&		//remark this for testing
				<div key={e.icon}
					className={'tic-grid-item'
						+ (e._selected || (e.value === null && !selected.length)? ' selected' : '')
						// + (content.length < 4? ' big' : content.length < 10? ' medium' : ' small')
						+ (' row' + size)
						+ (com.type === 'icon-grid'? ' icon' : '')
					}
					onClick={() => onSelect(e)}
					>
					{e.icon &&
						<Image src={e.icon} className='tic-grid-item-image' />
					}
					<Label src={e} className={'tic-grid-item-label' + (e.icon? '' : ' center')} />
				</div>
			)}
		</div>
	)
}


// ---------------------------------------------------------------------------- onSelectItem
const onSelectItem = (e, s, com) => {
	if (e.attribute){			//set bundle attribute
		com._bundle.attributes[e.attribute] = e._selected? e.value : null;
		console.log('---set attribute:', e.attribute, com._bundle.attributes[e.attribute], 'at:', com._bundle.id);
	}

	if (com.property){			//set bundle property value
		com._bundle[com.property] = s[0]?.value || null;
		console.log('---set property:', com.property, com._bundle[com.property], 'at:', com._bundle.id);

		if (com.property === 'bundletype_id'){		//package class selected

			com._bundle._bundleType = e._selected? e : null
			if (e._selected){
				console.log('nestable:', e.nestable)
				console.log('selected bundle:', com._bundle)
			}
		}
	}

	if (com.attribute && com._bundle.attributes){			//set bundle attribute
		com._bundle.attributes[com.attribute] = s.length === 0? null : s.length === 1? s[0].value : s.map(s => s.value);
		console.log('---set comp-attribute:', com.attribute, com._bundle.attributes[com.attribute]);
	}

	if (e.multiscanMode){
		com._bundle._multiscanMode = e._selected? e.multiscanMode : null
		console.log('   multiscanMode:', com._bundle._multiscanMode)
	}
}


// ---------------------------------------------------------------------------- Group
const Group = props => {
	const com = props.data;		//component
	const grp = com.content.find(c => c._selected) || com.content.find(e => e._valid);

	const [group, setGroup] = useState(grp);
	const [selected, setSelected] = useState(grp?.group?.filter(g => g._selected));

	if (!grp) return null

	const onSelectGroup = e => {
		if (e._selected){
			return;
			// e._selected = false;
			// setGroup(null);
		}else{
			if (group) group._selected = false;
			e._selected = true;
			setGroup(e);
		}
	}


	const onSelect = e => {
		console.log('select item:', e)
		
		let s;
		if (e._selected){
			e._selected = false;
			// setSelected([]);
			s = [];
		}else{
			if (selected[0]) selected[0]._selected = false;
			e._selected = true;
			// setSelected([e]);
			s = [e];
		}

		onSelectItem(e, s, com);

		setSelected(s);
	}

	let content = com.content;

	return (
		<div className='tic-group'>
			<div className='tic-button-group'>
				{content.map((e, i) =>
					e._valid &&
					<GroupButton key={i}
						className='tic-group-button'
						selected={group === e}
						onClick={() => onSelectGroup(e)}
						label={getLabel(e)}
					/>
				)}
			</div>
			<div className='tic-grid' >
				{(group && group.group) && group.group.map((e, i) =>
					e._valid &&
					<div key={e.icon} className={'tic-grid-item'
							+ (e._selected? ' selected' : '')
							// + (group.group.length < 4? ' big' : group.group.length < 10? ' medium' : ' small')
							// + (' row' + (RowSize[group.group.length] || 5))
							+ ' row5'
						}
						onClick={() => onSelect(e)}
						>
						<Image src={e.icon} className='tic-grid-item-image' />
						<Label src={e} className='tic-grid-item-label' />
					</div>
				)}
			</div>
		</div>
	)
}


// ---------------------------------------------------------------------------- PhotoGrid
const PhotoGrid = props => {
	const action = useContext(Action);
	const state = useContext(State);
	// const [selected, setSelected] = useState([]);

	let content = props.data.content;

	return (
		<div className='tic-photo-grid'>
			{content.map((e, i) =>
				<div key={i}
					className={'tic-photo-item'}
					onClick={evt => {
						if (evt.shiftKey){
							action('photo-clear', e)
						}else{
							action('photo-start', e)
						}
					}}
					style={{opacity:1}}
					>
					<Image src={e._photo || e.icon}
						className='tic-photo-item-image'
						padding={0} radius={0}
						icon='photo_camera'
					/>
					{/* <i className='material-icons'>photo_camera</i> */}
					<Label src={e} className='tic-photo-item-label' />
				</div>
			)}
		</div>
	)
}


// ---------------------------------------------------------------------------- Stepper
const Stepper = props => {
	const min = props.data.min || 0;
	const max = props.data.max || 100;
	const [value, setValue] = useState(props.data.value || min);
	const [edit, setEdit] = useState(false);

	const onChange = e => {
		e = String(e).replace(',', '.');
		if (e.startsWith('.')) e = '0' + e
		let n = Math.min( Math.max( min, Number(e) ), max)
		setValue(n);

		let com = props.data;
		com._bundle.attributes[com.attribute] = e;
console.log('---set property:', com.attribute, e, 'at:', com._bundle.id);
	}


	return (
		<div className='tic-stepper'>
			<div className='tic-stepper-icon'>
				<Image src={props.data.icon} height={60} padding={10} />
				{/* <Image src={'assets/icons/Lagen-2.png'} height={60} padding={10} /> */}
				<div className='tic-stepper-label'>{getLabel(props.data)}</div>
			</div>
			<div className='tic-stepper-value' onClick={e => setEdit(true)}>{value}</div>

			{edit &&
				<UI.NumPad className='tic-stepper-numpad'
					symbol={global.user?.unitSystem === 'metric'? ',': '.'}
					max={max} min={min}
					onChange={onChange}
					onClose={e => setEdit(false)}
				/>
			}

			<div className='tic-stepper-buttons'>
				<div className='tic-stepper-button up'
					onClick={e => {
						if (value < max) onChange(value + 1);
					}}
				/>
				<div className='tic-stepper-button down'
					onClick={e => {
						if (value > min) onChange(value - 1);
					}}
				/>
			</div>
		</div>
	)
}



// ---------------------------------------------------------------------------- CheckBox
const CheckBox = props => {
	const [selected, setSelected] = useState(props.data._bundle?.attributes[props.data.attribute] === '1');

	const onChange = e => {
		setSelected(e)
		let com = props.data;
		com._bundle.attributes[com.attribute] = e? '1' : '0';
console.log('---set property:', com.attribute, e, 'at:', com._bundle.id);
	}


	return (
		<div className='tic-checkbox'>
			<div className='tic-checkbox-label'>{getLabel(props.data)}</div>
			<CheckButton checked={selected} onClick={e => onChange(e)} />
		</div>
	)
}


// ---------------------------------------------------------------------------- DropDown
const DropDown = props => {
	const [selected, setSelected] = useState(props.data._bundle?.attributes[props.data.attribute]);


	const onChange = e => {
console.log('change', e)
		setSelected(e);

		let com = props.data;
		com._bundle.attributes[com.attribute] = e;
console.log('---set property:', com.attribute, e, 'at:', com._bundle.id);
	}


	return (
		<div className='tic-dropdown'>
			<div className='tic-dropdown-label'>{getLabel(props.data)}</div>
			<Dropdown selected={selected} options={props?.data?.settings?.options} onSelect={e => onChange(e)} />
		</div>
	)
}


// ---------------------------------------------------------------------------- Multiscan
const Multiscan = props => {
	const action = useContext(Action);
	const state = useContext(State);
	const bundle = props.data._bundle
	const [table, setTable] = useState(bundle._table);


	const onSelect = (id, data) => {	//table selected
		console.log('select table:', data);
		bundle._table = id;
		bundle._tableData = data;	//cache data from selected scan-table

		setTable(id);
	}

	// useEffect(() => {
	// 	if (props.selected) setTable(state.setup._table);
	// }, [props.selected])

	// const tables = props.data.multiscans.filter(e => e.warehouse_id === state.warehouse.id);
	const tables = props.data.multiscans.filter(e => e.warehouse_id === state.warehouse.id)
		.map(table => {
			let tid = table.warehouse_id + '.' + table.id
			return state.tables[tid] || table
		})
	const values = bundle.attributes;
	const unit = state.user.unitSystem === 'metric'? 'mm' : 'in';
	const unitW = state.user.unitSystem === 'metric'? 'g' : 'lb';
	const unitF = state.user.unitSystem === 'metric'? 1 : 25.4;
	const unitFW = state.user.unitSystem === 'metric'? 1 : 453.59237;


	useEffect(() => {
		console.info('---multiscan:', bundle.id, props.data, props)
		if (tables.length === 1){		//preselect first table if only 1
			bundle._table = tables[0].id;
			bundle._tableData = tables[0];		//take first table data as default
			setTable(tables[0].id);
		}
	}, [])

	return (
		<div className='tic-multiscan'>
			<div className='tic-m-row fix center'>
			{state.useNestedScan ?
				<InputLabel
					label={global.getLabel('dimensions-nested-height', 'Nested Height') + ':'}
					value={getValue(values.nestedHeight / unitF) || 0}
					unit={unit}
					onChange={e => {
						values.nestedHeight = getValue(e * unitF)
						values.nesting_bonus = Number(values.height) * 2 - Number(values.nestedHeight)
					}}
				/>
				:
				<>
					<InputLabel
						label={global.getLabel('dimensions-length') + ':'}
						value={getValue(values.length / unitF) || 0}
						unit={unit}
						onChange={e => {values.length = getValue(e * unitF)}}
					/>
					<InputLabel
						label={global.getLabel('dimensions-width') + ':'}
						value={getValue(values.width / unitF) || 0}
						unit={unit}
						onChange={e => values.width = getValue(e * unitF)}
					/>
					<InputLabel
						label={global.getLabel('dimensions-height') + ':'}
						value={getValue(values.height / unitF) || 0}
						unit={unit}
						onChange={e => values.height = getValue(e * unitF)}
					/>
					<InputLabel
						label={global.getLabel('dimensions-weight') + ':'}
						value={getValue(values.weight / unitFW) || 0}
						unit={unitW}
						onChange={e => values.weight = getValue(e * unitFW)}
					/>
					{props.data.additionalAttributes?.map((e, i) => e._valid &&
						<InputLabel
							key={i}
							label={global.getLabel(e.label, 'Toleranz (Gewicht)') + ':'}
							value={getValue(values[e.attribute] / unitFW) || 0}
							unit={unitW || e.unit}
							onChange={c => values[e.attribute] = getValue(c * unitFW)}
						/>
					)}
				</>
			}
			</div>

			<div className='tic-multiscan-image'>
				{/* <img src={props.data.image} alt='' /> */}
				<img src={'assets/icons/tisch.png'} alt='' />
			</div>

			<div className={'tic-tables'}>
				{tables.length > 1 &&
					<div className='tic-tables-list'>
						{tables.map(t =>
							<SelectButton key={t.id}
								selected={t.id === table}
								onClick={() => onSelect(t.id, t)}
							>{t.label}</SelectButton>
						)}
					</div>
				}
				<SelectButton
					className='tic-multiscan-button'
					disabled={tables.length > 1 && table === undefined}
					selected={true}
					label={state.measure_on? 'scanning...' :
						// (state.useNestedScan? 'scan nested case' : getLabel(props.data))}
						getLabel(props.data)}

					primary
					onClick={e => {
						if (!state.measure_on) action('measure-start', bundle);
					}}
				/>
				<SelectButton
					className='tic-multiscan-button'
					disabled={tables.length > 1 && table === undefined}
					selected={false}
					label={global.getLabel('multiscan-ref-manually')}
					primary
					onClick={e => {
						if (!state.measure_on) action('ref-start', bundle);
					}}
				/>
			</div>

{state.mseError &&
	<UI.Dialog open={true} close={false}
		header='ERROR!'
		footer={
			state.mseErrorCode === '26' ?	//Not Referenced
			<>
				<StyleButton width={120} label='Reference' onClick={e => {
					action('ref-start', bundle);
				}} />
				<StyleButton width={120} label={global.getLabel('cancel')} onClick={e => {
					action('measure-complete');
				}} />
			</>
			:
			<StyleButton label='OK' onClick={e => {
				action('measure-complete');
			}} />
		}>
		<div className='mse-error-message'>
			{state.mseErrorCode &&
				<div>{'ErrorCode: ' + state.mseErrorCode}</div>
			}
			<div>{state.mseErrorMessage}</div>
		</div>
	</UI.Dialog>
}
		</div>
	)
}


// ---------------------------------------------------------------------------- getValue
// round to 3 digits
const getValue = val => {
	return Math.round(Number(val) * 1000) / 1000;
}


// ---------------------------------------------------------------------------- InputLabel
const InputLabel = props => {
	const [value, setValue] = useState(props.value);
	const [edit, setEdit] = useState(false);


	const onChange = e => {
		let val = e.target.value
		if (isNaN(val)) return

		if (parseFloat(val) < 0) val = 0
		setValue(val);
		if (props.onChange) props.onChange(val);
	}

	useEffect(() => {
		setValue(props.value);
	}, [props.value]);


	return (
		<div className='input-field'>
			<div className='input-label'>{props.label}</div>

			<input
				className='input-value'
				// type="tel"
				// pattern="[0-9]*"
				// pattern="^(0*[,.]*[0-9][0-9]*([,.][0-9]+)*|[0-9]?[,.][0-9]*[1-9][0-9]*)$"
				//see: https://stackoverflow.com/questions/27103646/html5-input-type-number-with-regex-pattern-in-mobile
				type='number'
				// inputmode='decimal'
				value={value}
				min={0}
				// keyboardType="numeric"
				onChange={onChange}
			/>
			<span>{props.unit}</span>
		</div>
	)
}



// ---------------------------------------------------------------------------- Image
const Image = props => {
	const [error, setError] = useState();
	const [src, setSrc] = useState()

	useEffect(() => {
		loadImage(props.src)
	}, [])

	const loadImage = async (url) => {
		let img = await CacheManager2.get(props.src)
		setSrc(img)
	}

	return (
		<div id={props.id}
			className={'tic-image' + (props.className? ' ' + props.className : '')}
			onClick={props.onClick}
			style={{
				width : parseCSS(props.width),
				height : parseCSS(props.height),
				padding : parseCSS(props.padding),
				...props.style
			}}
			>
			{props.icon &&
				<i className='material-icons'>{props.icon}</i>
			}
			{props.src &&
				<img
					src={src}
					alt=''
				/>
			}
		</div>
	)
}



//----------------------------------------------------------------------------- parseCSS
const parseCSS = value => {
	return value && (typeof value === 'number'? value+'px' : value);
}


// ---------------------------------------------------------------------------- Label
const Label = e => {
	if (!e.src && !e.src.label) return null;

	let label = (typeof e.label === 'string')?
		e.label :
		global.getLabel(e.src.label);

	return (
		<>
			<div className={e.className} onClick={e.onClick}>
				{label}
			</div>
			{e.src.nestable && <span className='tic-grid-nested-icon'>Ⓝ</span>}
		</>
	)
}


// ---------------------------------------------------------------------------- getLabel
const getLabel = e => {
	return !e.label? null : typeof e.label === 'string'? e.label : global.getLabel(e.label);
}


// ---------------------------------------------------------------------------- CaseSummary
const CaseSummary = props => {
	const action = useContext(Action);
	const state = useContext(State);

	return (
		<div className='tic-button-menu'>
			{(!state.setup._isToiletpaper && state.setup._pack && state.setup._pack._valid) &&
				<StyleButton onClick={e => action('teach-pack')} label={global.getLabel('goto_pack_button', 'PACK')} />
			}
			{(!state.setup._isToiletpaper && state.setup._unit && state.setup._unit._valid) &&
				<StyleButton onClick={e => action('teach-unit')} label={global.getLabel('goto_unit_button', 'UNIT')} />
			}
			<StyleButton onClick={e => action('teach-in-complete')} label={global.getLabel('complete', 'Abschließen')} />
		</div>
	)
}


// ---------------------------------------------------------------------------- Summary
const Summary = props => {
	const state = useContext(State);

	if (!props.selected) return null;

	let ch = state.setup._chapters;
	let carrier = state.carriers.find(ca => ca.id === state.bundle.loadcarrier_id);

	return (
		<div className='tic-summary'>
		<div className='tic-summary-list'>
			{
				ch.map(c => {
					if (!c._valid || c.id > 4) return null;
					let param = c.id === 1?	{
						width: carrier.width_mm,
						height: carrier.height_mm,
						depth: carrier.length_mm,
						weight: carrier.weight,
					}: c._bundle.attributes		//1 = palette else attributes from bundle

					let label = getLabel(c);
					return (
						<div className='tic-result-col' key={label}>
							<div className='tic-result-col-title'>{label}</div>
							{
								c.pages.map((p, i) => {
									if (!p._valid) return null;

									return p.sections.map((s, sn) => {
										let slabel = getLabel(s);
										let n = 0;
										return (
											<div key={sn} className='tic-result-row'>
												<div className='tic-result-label'>{slabel? slabel + ':' : ''}</div>

												<div className='tic-result-values'>
													{s.components.map(com => {
														if (com.type === 'grid'){
															return com.content.map(c => {
																if (!c._selected) return null;
																let clabel = getLabel(c);
																return (
																	<div key={n++} className='tic-result-value' >
																		<span>{clabel}</span>
																		<img src={c.icon} alt='' />
																	</div>
																)
															})
														}else if (com.type === 'photo-grid'){
															return com.content.map(c => c._photo &&
																<div key={n++} className='tic-result-value' >
																	<span>{getLabel(c)}</span>
																	<img src={c._photo} alt='' />
																</div>
															)
														}else if (com.type === 'stepper'){
															let clabel = getLabel(com);
															return (
																<div key={n++} className='tic-result-value'>
																	<span>{clabel + ': ' + (com.value)}</span>
																	<img src={com.icon} alt='' />
																</div>
															)
														}
													})}
												</div>
											</div>
										)
									})
								})
							}
							<div className='tic-result-row inline'>
								<div className='tic-result-label'>Breite:</div>
								<div className='tic-result-value'>{param.width + ' mm'}</div>
							</div>
							<div className='tic-result-row inline'>
								<div className='tic-result-label'>Höhe:</div>
								<div className='tic-result-value'>{param.height + ' mm'}</div>
							</div>
							<div className='tic-result-row inline'>
								<div className='tic-result-label'>Tiefe:</div>
								<div className='tic-result-value'>{param.depth + ' mm'}</div>
							</div>
							<div className='tic-result-row inline'>
								<div className='tic-result-label'>Gewicht:</div>
								<div className='tic-result-value'>{param.weight + ' g'}</div>
							</div>
						</div>
					)
				})
			}
		</div>
		</div>
	)
}


// ---------------------------------------------------------------------------- SlipSheets
// slipsheet_top (boolean) slipsheet_bottom (boolean) slipsheets_inner (enum: none/some/all), slipsheets_self_supporting (boolean)

const SlipSheets = props => {
	const state = useContext(State);
	const com = props.data;		//component
	const _enum = ['none', 'some', 'all'];
	const attr = com._bundle.attributes;

	const [S3, setS3] = useState(Number(attr.slipsheet_top) || 0);
	const [S2, setS2] = useState(attr.slipsheets_inner || _enum[0]);
	const [S1, setS1] = useState(Number(attr.slipsheet_bottom) || 0);

	const nextPage = useRef();


	useEffect(() => {
		nextPage.current = state.setup._pages[state.teachInPage + 1];

		attr.slipsheet_top = S3;
		attr.slipsheets_inner = S2;
		attr.slipsheet_bottom = S1;

		nextPage.current._active = attr.slipsheet_top > 0 || attr.slipsheets_inner !== _enum[0] || attr.slipsheet_bottom > 0;
	}, [])


	const onSelect = (s, i) => {
		switch (s) {
		case 3:
			attr.slipsheet_top = i;
			setS3(i);
			break;
		case 2:
			attr.slipsheets_inner = _enum[i];
			setS2(_enum[i]);
			break;
		case 1:
			attr.slipsheet_bottom = i;
			setS1(i);
			break;
		default:
		}
		nextPage.current._active = attr.slipsheet_top > 0 || attr.slipsheets_inner !== _enum[0] || attr.slipsheet_bottom > 0;
	}

	const yes = global.getLabel('select-yes').toUpperCase();
	const no = global.getLabel('select-no').toUpperCase();
	const inner = global.getLabel('select-inner').toUpperCase();
	const all = global.getLabel('select-all').toUpperCase();

	return (
		<div className='slip-sheets'>
			<div className='slip-sheets-images'>
				<img alt='' src='assets/sheets/s01a.png' />
				{S1 === 1 && <img alt='' src='assets/sheets/s01b.png' />}

				<img alt='' src='assets/sheets/s02a.png' />
				{S2 === _enum[1] && <img alt='' src='assets/sheets/s02b.png' />}
				{S2 === _enum[2] && <img alt='' src='assets/sheets/s02c.png' />}

				<img alt='' src='assets/sheets/s03a.png' />
				{S3 === 1 && <img alt='' src='assets/sheets/s03b.png' />}
			</div>

			<div className='slip-sheets-select'>
				<div className='slip-sheets-label'>Top Slipsheets:</div>
				<div className='slip-sheets-buttons'>
					<div
						className={'slip-sheets-button' + (S3 === 0? ' selected' : '')}
						onClick={e => onSelect(3, 0)}
					>{no}</div>
					<div
						className={'slip-sheets-button' + (S3 === 1? ' selected' : '')}
						onClick={e => onSelect(3, 1)}
					>{yes}</div>
				</div>

				<div className='slip-sheets-label'>Inner Slipsheets:</div>
				<div className='slip-sheets-buttons'>
					<div
						className={'slip-sheets-button' + (S2 === _enum[0]? ' selected' : '')}
						onClick={e => onSelect(2, 0)}
					>{no}</div>
					<div
						className={'slip-sheets-button' + (S2 === _enum[1]? ' selected' : '')}
						onClick={e => onSelect(2, 1)}
					>{inner}</div>
					<div
						className={'slip-sheets-button' + (S2 === _enum[2]? ' selected' : '')}
						onClick={e => onSelect(2, 2)}
					>{all}</div>
				</div>

				<div className='slip-sheets-label'>Bottom Slipsheets:</div>
				<div className='slip-sheets-buttons'>
					<div
						className={'slip-sheets-button' + (S1 === 0? ' selected' : '')}
						onClick={e => onSelect(1, 0)}
					>{no}</div>
					<div
						className={'slip-sheets-button' + (S1 === 1? ' selected' : '')}
						onClick={e => onSelect(1, 1)}
					>{yes}</div>
				</div>
			</div>
		</div>
	)
}


// ---------------------------------------------------------------------------- GTinView
const GTinView = props => {
	const com = props.data;		//component
	const action = useContext(Action);
	const state = useContext(State);
	// const inputRef = useRef();
	const [value, setValue] = useState(com._bundle.gtin || '')

	const onChange = val => {
		com._bundle.gtin = val;
		setValue(val);
	}

	useEffect(e => {
		setValue(com._bundle.gtin || '');
	}, [com._bundle.gtin])


	return (
		<div className='gtin-view'>
			{state.isScanning ?
				state.message ?
					<UI.Backdrop title={state.message.text}>
						<StyleButton label='OK' onClick={e => action('scan-close')} />
					</UI.Backdrop>
					:
					<UI.Backdrop spinner title='Start Barcode-Scanner ...'>
						<StyleButton label={global.getLabel('cancel')} onClick={e => action('scan-close')} />
					</UI.Backdrop>
				:
				<>
					{state.isConnected &&
						<StyleButton width={300}
							label={global.getLabel(com.label, 'scan gtin') + ' (barcode)'}
							onClick={e => {
								state.bundleItem = com._bundle;
								action('scan-barcode', 'gtin');
							}
						}
						/>
					}

					{!state.warehouse.disableBarcodeScan &&
						<StyleButton width={300}
							// label={global.getLabel('start-scan')}
							label={global.getLabel(com.label, 'scan gtin') + (state.isConnected? ' (camera)' : '')}
							onClick={e => {
								state.bundleItem = com._bundle;
								action('scan-start', 'gtin');
							}}
						/>
					}

					<div className='search-input'>
						<TextField
							label={global.getLabel('gtin-input', 'GTIN')}
							style={{fontSize:24, width:300, margin:40}}
							// inputRef={inputRef}
							inputRef={input => input && input.focus()}

							onChange={e => onChange(e.target.value)}
							value={value}
						/>

						{value &&
							<CloseButton onClick={() => onChange('')} size={20} width={50} height={50} />
						}
					</div>
				</>
		}

		</div>
	)
}


// ---------------------------------------------------------------------------- components
const components = {
	'textbox'		: Textbox,
	'image-grid'	: GridView,
	'icon-grid'		: GridView,
	'photo-grid'	: PhotoGrid,
	group			: Group,
	stepper			: Stepper,
	multiscan		: Multiscan,
	'case-summary'	: CaseSummary,
	'summary'		: Summary,
	slipsheets		: SlipSheets,
	gtin			: GTinView,
	boolean			: CheckBox,		//item-attribute
	enum			: DropDown,		//item-attribute
	//number ???
}
